<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapState,mapGetters,mapActions } from "vuex"
import Swal from "sweetalert2";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Production Factories",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader
  },
  data() {
    return {
      title: "Production Factories ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Production Factories",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      existingFactory: [],
      nameError: "",
      contactError: "",

      // Value from user input for adding unit
      data: {
        name: "",
        contact: "",
        location: "",
      },
      // edit unit
      editdata: {
        name: "",
        contact: "",
        location: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "type",
      "message",
      "show",
    ]),
    ...mapGetters("production", ["SaveStatus", "ProductionFactories"]),
    ...mapGetters("auth", ["MyUserPerm","branchid"]),

    fields() {
      let baseFields = [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "name",
          sortable: true,
          label: "NAME",
        },
        {
          key: "contact",
          sortable: true,
          label: "CONTACT",
        },
        {
          key: "location",
          sortable: true,
          label: "LOCATION",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ];
      return baseFields;
    },

    /**
     * Total no. of records
     */

    rows() {
      return this.ProductionFactories ? this.ProductionFactories.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ProductionFactories ? this.ProductionFactories.length : 1;
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchProductionFactories: "production/fetchProductionFactories",
      AddFactory: "production/addProductionFactory",
      EditFactory: "production/editProductionFactory",
      DeleteFactory: "production/deleteProductionFactory"
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },



    // Validate Factory Data
    validateFactory(){
      if (this.data.name !="" && this.data.contact!=''){
        let factoryData = this.ProductionFactories.filter((item)=>{
          return  item.contact ==  parseInt(this.data.contact) ;
        })
        let factoryCount =factoryData.length;
        if (factoryCount>0){
          this.contactError="Factory with contact "+this.data.contact+"  already Exists";
        }
      }else if(this.data.name !="" && this.data.contact ==''){
        let factoryData = this.ProductionFactories.filter((item)=>{
          return  (item.name).toLowerCase() ==  (this.data.name).toLowerCase() ;
        })
        let factoryCount =factoryData.length;
        if (factoryCount>0){
          this.contactError="Factory with these details already Exists";
        }
      }
    },

    addFactory(modalId) {
      this.modal_id = modalId;
      if (this.data.name === "") {
        this.nameError = "Name field is required";
        return;
      } else {
        this.nameError = "";
      }
      this.validateFactory()
      if (this.contactError!=""){
        return
      }
      this.AddFactory(this.data);
    },

    resetAdd() {
      this.data.name = "";
      this.data.contact = "";
      this.data.location = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.data.name = "";
      this.data.id = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
      this.contactError = "";
    },
    showEditModal(val) {
      this.editdata.name = val.item.name;
      this.editdata.contact = val.item.contact;
      this.editdata.location = val.item.location;
      this.editdata.id = val.item.id;
    },
    editFactory(modalId) {
      this.modal_id = modalId;
      this.validateFactoryEdit()
      if (this.contactError!=""){
        return
      }
      this.EditFactory(this.editdata);
    },
    validateFactoryEdit(){
      if (this.editdata.name !="" && this.editdata.contact!=''){
        let selectedFactory = this.ProductionFactories.filter((item)=>{
          return  (item.phone ==  parseInt(this.editdata.contact)) && (item.id != this.editdata.id) ;
        })
        let factoryCount =selectedFactory.length;
        if (factoryCount>0){
          this.contactError="Factory with contact "+this.editdata.contact+"  already Exists";
        }
      }else if(this.editdata.name !="" && this.editdata.contact ==''){
        let selectedFactory = this.ProductionFactories.filter((item)=>{
          return  (item.name).toLowerCase() ==  (this.editdata.name).toLowerCase() ;
        })
        let factoryCount =selectedFactory.length;
        if (factoryCount>0){
          this.contactError="Factory with these details already Exists";
        }
      }
    },
    showDeleteModal(val) {
      this.deletedata.name = val.item.name;
      this.deletedata.id = val.item.id;
    },
    deleteFactory(modalId) {
      this.modal_id = modalId;
      this.DeleteFactory(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },

    showMergeModal(data){
      this.mergedata.name = data.item.name;
      this.mergedata.id = data.item.id;
    },

    mergeFactory(modalId) {
      this.modal_id = modalId;
      this.MergeFactory(this.mergedata);
    },

    resetMerge() {
      this.mergedata.name = "";
      this.mergedata.id = "";
      this.modal_id = "";
    },
  },
  created() {
    this.FetchProductionFactories();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-9">
                <h4 class="card-title">Production Factories</h4>
              </div>
              <div v-if="branchid != 0" class="col-md-3" align="right">
                <b-button v-b-modal.add-factory-modal variant="primary"><i class="fa fa-plus"></i> Add New</b-button>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                        class="form-select form-select-sm"
                        v-model="perPage"
                        size="sm"
                        :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                        v-model="filter"
                        type="search"
                        placeholder="Search..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="ProductionFactories?ProductionFactories:[]"
                  :fields="fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :sort-desc.sync="sortDesc"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(actions)="data">
                <b-button-group>
                  <b-button
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-factory-modal
                      @click="showEditModal(data)"
                  ><i class="fa fa-edit"></i></b-button
                  >
                  <b-button
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-factory-modal
                      @click="showDeleteModal(data)"
                  ><i class="fa fa-trash"></i></b-button
                  >
                </b-button-group>
                </template>
              </b-table>
            </div>
            <Loader  v-if="!ProductionFactories"/>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="rows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- modal starts -->
    <b-modal id="add-factory-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add Factory </template>

      <div class="form-group mb-3">
        <label>Factory Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="text"
              placeholder="Enter Name "
              class="form-control"
              @input="resetError()"
              v-model="data.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Contact <em class="text-info">(start with country code e.g. 256)</em></label>
        <div class="input-group">
          <input
            type="number"
            placeholder="Enter Phone Number"
            class="form-control"
            v-model="data.contact"
            @input="resetError()"
          />
        </div>
        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Factory Location</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Enter Location"
            class="form-control"
            v-model="data.location"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-factory-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="addFactory('add-factory-modal')"
        > <i class="fa fa-check"></i>
          Submit
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
    <!--     edit modal starts-->
    <b-modal id="edit-factory-modal" hide-footer @hidden="resetEdit">
      <template #modal-title> Edit Factory {{ editdata.name }}</template>
      <div class="form-group mb-3">
        <label>Factory Name <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="text"
              class="form-control"
              @input="resetError()"
              v-model="editdata.name"
          />
        </div>
        <div class="text-danger" v-if="nameError">
          <em>{{ nameError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Contact <em class="text-info">(start with country code e.g. 256)</em></label>
        <input
            type="number"
            class="form-control"
            @input="resetError()"
            v-model="editdata.contact"
        />

        <div class="text-danger" v-if="contactError">
          <em>{{ contactError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Factory Location <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
              type="text"
              class="form-control"
              v-model="editdata.location"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-factory-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-primary"
            @click="editFactory('edit-factory-modal')"
        > <i class="fa fa-check"></i>
          Save Changes
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Saving"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->

    <!-- modal delete product starts -->
    <b-modal
        header-bg-variant="danger"
        header-text-variant="light"
        body-text-variant="danger"
        footer-bg-variant="danger"
        footer-text-variant="danger"
        id="delete-factory-modal"
        hide-footer
        @hidden="resetDelete"
    >
      <template #modal-title> Delete Factory {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-factory-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
            type="button"
            class="btn btn-danger"
            @click="deleteFactory('delete-factory-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
          <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Deleting"
          ></b-spinner>
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
.btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
</style>
